export default __webpack_public_path__ + "static/Tapetsering1-2fa898b8a4f40a431739bf9efb6ab64d.jpg";